export default __webpack_public_path__ + "static/char-s-sp03-zh-Hant-9348fa5a23afecf0d6d86a1d122f9d72.webp";